<mat-radio-group [formControl]="formControlRef" aria-label="Select an option">
  <mat-radio-button [value]="true" class="me-3">{{'Sellers.Products.Yes' | translate}}</mat-radio-button>
  <mat-radio-button [value]="false">{{'Sellers.Products.No' | translate}}</mat-radio-button>
</mat-radio-group>
